import { FooterLinks, LineSeparator } from 'components/BKJMainNavigation/BKJMainNavigation.styled';
import { ExternalNavMenuItem } from 'components/BKJMainNavigation/src/ExternalNavMenuItem';
import { IWebNavFooterProps } from 'components/BKJMainNavigation/src/Web/WebNavFooter.types';
import { FC, memo } from 'react';
import { useUserActions } from 'store/reducers/auth/authReducer';
import { deepEquals } from 'utils/deepEquals';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
import { useTranslation } from 'hooks/useTranslation';
import { PAGE_URLS } from 'components/BKJMainNavigation/BKJMainNavigation.constants';
import { InternalNavMenuItem } from 'components/BKJMainNavigation/src/InternalNavMenuItem';
import { NavMenuItem } from 'components/BKJMainNavigation/src/NavMenuItem';
import { Flex } from '@awais4123/fillify-design-library';

const getHelpDeskLink = () => {
  const { whiteLabelProvider } = WhiteLabelAccessor;
  switch (whiteLabelProvider) {
    default:
      return '';
  }
};

const Component: FC<IWebNavFooterProps> = ({ disabled, isOpen, onClose }) => {
  const { userLogout } = useUserActions();
  const { t } = useTranslation();
  const { isXtmProvider } = WhiteLabelAccessor;
  return (
    <FooterLinks>
      <ExternalNavMenuItem
        href={getHelpDeskLink()}
        label={t('navigation:SUPPORT')}
        icon="Question"
        disabled={disabled.current}
        isOpen={isOpen}
        onClick={(e) => {
          onClose(e);
          e.preventDefault();
          return window.open(getHelpDeskLink(), '_blank');
        }}
      />
      <InternalNavMenuItem
        path={PAGE_URLS.SETTINGS}
        label={t('navigation:SETTINGS')}
        icon="Settings"
        data-cy="NavMenuItems-Settings"
        disabled={disabled.current}
        isOpen={isOpen}
        onClick={onClose}
      />
      <Flex padding="0 10px 0 8px">
        <LineSeparator />
      </Flex>
      {!isXtmProvider && (
        <NavMenuItem
          label={t('navigation:LOGOUT')}
          icon="Logout"
          data-cy="logout"
          disabled={disabled.current}
          isOpen={isOpen}
          onClick={(e) => {
            userLogout();
            onClose(e);
          }}
        />
      )}
    </FooterLinks>
  );
};

export const WebNavFooter = memo(Component, deepEquals);
